import {
  Component,
  OnInit,
  Input,
  HostListener,
  EventEmitter,
  Output,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
  standalone: false,
})
export class NavigationBarComponent implements OnInit {
  // Inputs/Outputs
  @Input() public isLight = false;
  @Input() public linearBackground = false;
  @Output() public menuToggled = new EventEmitter<void>();

  // Public properites.
  public scrollingPosition: number;
  public showSlidingMenu: boolean = false;
  public backOfficeURL: string;

  constructor(
    private router: Router,
    private $gaService: GoogleAnalyticsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.scrollingPosition = 0;
    this.backOfficeURL = environment.backOfficeURL;
  }

  // DOM manipulation.
  /**
   *
   */
  @HostListener('window:scroll', ['$event'])
  public updateScrollPosition(): void {
    this.scrollingPosition = isPlatformBrowser(this.platformId)
      ? window.scrollY
      : 0;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.showSlidingMenu = false;
  }

  /**
   * closeMenu
   */
  public closeMenu(): void {
    this.showSlidingMenu = !this.showSlidingMenu;
    this.menuToggled.emit();
  }

  /**
   * opens sliding menu.
   *
   */
  public openMenu(): void {
    this.menuToggled.emit();
    this.showSlidingMenu = !this.showSlidingMenu;
  }

  /**
   * Navigates user to home page.
   */
  public navigateToHome(): void {
    this.router.navigate(['/']);
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0); // reset the scroll position to the top left of the document.
    }
  }

  /**
   * Sends a google event.
   */
  public googleCta(): void {
    this.$gaService.event('Top-Menu-Publish-CTA', 'Click', 'Publish-CTA');
  }
}
